import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const needsEscape = (v: unknown) => typeof v === 'string' && /^[=+\-@].+/.test(v);
const escapeCell = (v: unknown) => (needsEscape(v) ? `'${v}` : v);

export const exportToExcel = <T>(data: T, filename: string) => {
  const rows = Array.isArray(data) ? data : [data];
  const safe = rows.map((row) => Object.fromEntries(Object.entries(row).map(([k, v]) => [k, escapeCell(v)])));
  const worksheet = XLSX.utils.json_to_sheet(safe);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, filename);
};
